import Link, { LinkVariant } from '@/components/link';
import Typography, { TypographyColor } from '@/components/typography';

export type RelatedLink = {
  title: string;
  url?: string | null;
};
type RelatedLinksProps = {
  title: string;
  links: RelatedLink[];
};

export default function RelatedLinks({ title, links }: RelatedLinksProps) {
  return (
    <div className='min-w-fit rounded-lg bg-gray-50 p-4 sm:p-6'>
      <Typography.Heading6 color={TypographyColor.DEFAULT}>
        {title}
      </Typography.Heading6>

      <div className='mt-4'>
        <ul>
          {links.map((link, index) => (
            <li key={index} className='mb-1'>
              <RelatedLinksText {...link} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function RelatedLinksText({ url, title }: RelatedLink) {
  if (!url) {
    return <Typography.Body1>{title}</Typography.Body1>;
  }

  return (
    <Link
      href={url}
      variant={LinkVariant.LINK}
      className='text-primary-extra-dark'
    >
      {title}
    </Link>
  );
}
